import React from 'react';
import LandPageTypes from '../LandPageTypes';
import {Carousel} from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.css';

class Roulette extends React.Component {

    constructor(props) {
        super(props);
        this.interval = 150; // ms
        this.maxDuration = 5000; // ms
        this.state = {
            duration: 0,
            item: 0,
            stop: false,
        };
        this.onChangeItem = this.onChangeItem.bind(this);
    }

    componentDidMount() {
        const minHeight = Math.min.apply(null, $('.slide').map((i, e) => $(e).height()).get());
        $('.slider-wrapper.axis-vertical').height(minHeight);
    }

    onChangeItem(index, element) {
        this.setState(oldState => {
            oldState.duration += this.interval;
            oldState.item = index;
            oldState.stop = this.maxDuration <= oldState.duration;
            return oldState;
        });
        if (this.state.duration >= this.maxDuration) {
            const winner = this.props.sorteio.participants[index];
            const winners = this.props.sorteio.winners.concat([winner]);
            this.props.events.onUpdateLotteryConfig('winners', winners);
            this.props.events.onUpdateLotteryConfig('participants', []);
            this.props.events.onAddLotteryWinner(this.props.sorteio.gameId, this.props.sorteio.credenciados.find(c => c.name === winner).id, this.props.token);
        }
    }

    render() {
        return (
            <Carousel axis="vertical"
                showArrows={false} showStatus={false} showIndicators={false} showThumbs={false}
                infiniteLoop={true} autoPlay={!this.state.stop} stopOnHover={false} dynamicHeight={false}
                onChange={this.onChangeItem} interval={this.interval} transitionTime={30} selectedItem={this.state.item}>
                {this.props.children}
            </Carousel>
        );
    }
}

class Lottery extends React.Component {

    componentDidUpdate() {
        const app = this.props.app;
        if (app.landPage === LandPageTypes.LOTTERY) {
            $('html').css({
                background: "url(imgs/" + require('../../../resources/imgs/background.png') + ") no-repeat center center fixed",
                backgroundSize: "cover",
            });
            $('body').css({
                backgroundColor: "transparent",
                paddingTop: "0",
            });
        } else {
            $('html').removeAttr("style");
            $('body').removeAttr("style");
        }
        const p = $('#winners');
        p.scrollTop(p.prop('scrollHeight'));
    }

    render() {
        const app = this.props.app;
        if (app.landPage !== LandPageTypes.LOTTERY)
            return null;

        const winners = this.props.sorteio.winners;
        const text = !winners.length ?  "Clique no botão para sortear" : "Parabéns " + winners[winners.length - 1];
        const isFinished = winners.length == this.props.sorteio.prizesCount;
        const participants = this.props.sorteio.participants;
        const headerStyle = {"fontSize": "72px", "color": "#990000", "fontWeight": "bold", "textShadow": "-2px 0 white, 0 2px white, 2px 0 white, 0 -2px white"};
        const resultStyle = {"fontSize": "42px"};

        return (
            <div className="container-fluid">
                <div className="row">
                    <button type="button" className="btn btn-sm btn-default pull-right"
                        onClick={this.props.events.onCloseLottery}>
                        <i className="glyphicon glyphicon-remove"></i>
                    </button>
                </div>
                <div className="row">
                    <div className="col-sm-10 col-sm-offset-1 text-center">
                        {participants.length == 0 &&
                            <div>
                                <h1 style={headerStyle}>{text}</h1>
                            </div>
                        }
                        {participants.length != 0 &&
                            <div style={{"borderStyle": "solid", "borderWidth": "medium", "borderColor": "LawnGreen"}}>
                                <Roulette {...this.props}>
                                    {participants.map((p, i) => (
                                        <h1 key={i} style={{"fontSize": "72px"}}>{p}</h1>
                                    ))}
                                </Roulette>
                            </div>
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-8 col-sm-offset-2">
                        <button className="btn btn-warning pull-right"
                            disabled={isFinished || participants.length}
                            onClick={this.props.events.onRunLottery}>
                            <span className="glyphicon glyphicon-gift"></span> Sortear
                        </button>
                    </div>
                </div>
                {!!winners.length &&
                    <div className="navbar navbar-default navbar-fixed-bottom" style={{"borderStyle": "none", "backgroundColor": "transparent"}}>
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-10 col-sm-offset-1">
                                    <div className="panel panel-color panel-primary">
                                        <div className="panel-heading">
                                            <h3 className="panel-title">Ganhador(es)</h3>
                                        </div>
                                        <div className="panel-body" id="winners" style={{"height": "40vh", "overflowY":"scroll"}}>
                                            <div className="table-responsive">
                                                <table className="table">
                                                    <tbody>
                                                        {winners.map((w, i) => (
                                                            <tr key={i} style={resultStyle}>
                                                                <td>{w}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default Lottery;



// WEBPACK FOOTER //
// src/views/landpages/Lottery.jsx